import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string
  description: string
  confirmFn: any
}

const AlertDialog = React.forwardRef((props: Props, ref) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState<any>()

  const handleClickOpen = (id: any) => {
    setOpen(true)

    setDeleteId(id)
  }

  const handleClose = () => {
    setOpen(false)

    setDeleteId(null)
  }

  React.useImperativeHandle(ref, () => {
    return { handleClickOpen, handleClose }
  })

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.description}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            {t('cancel')}
          </Button>

          <Button
            variant="contained"
            onClick={() => {
              handleClose()

              props.confirmFn && props.confirmFn(deleteId)
            }}
            autoFocus
          >
            {t('confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
})

export default AlertDialog
